import Block from 'quill/blots/block';

class IndentedBlockBlot extends Block {
  insertAt(index, value, def) {
    super.insertAt(index, value, def);
    this._updateBreakClass();
  }

  insertBefore(blot, ref) {
    super.insertBefore(blot, ref);
    this._updateBreakClass();
  }

  _updateBreakClass() {
    const { tail } = this.children;
    const tag = tail && tail.domNode.tagName;
    const endsWithBreak = tag === 'BR';
    this.domNode.classList.toggle('ends-with-break', endsWithBreak);
  }
}

export default IndentedBlockBlot;
